import { useEffect } from 'react'

type Props = {
  text: string
}

const MathJaxView = ({ text }: Props) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '/tools/resources/mathjax/MathJax.js?config=TeX-MML-AM_CHTML'
    script.async = true
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  useEffect(() => {
    if ((window as any).MathJax)
      (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, 'preview'])
  }, [text])
  return <div>{text}</div>
}

export default MathJaxView
